// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"402":"953ee666","453":"aa66cc60","859":"27695a91"}[chunkId] + ".chunk.js";
};